<template>
  <!-- ERROR -->
  <template v-if="agid">
    <div class="row ic1-centered">
      <div class="ic1-col-6" :class="errorTypeDanger ? 'ic1-card-error' : 'alert alert-warning'">
        <h2 class="ic1-text-heading-2">{{ getErrorTitle(errorTitle) }}</h2>
        <p class="ic1-text-subtitle-2">{{ getErrorMessage(errorMessage) }} </p>
        <p class="ic1-text-subtitle-2">{{ getErrorCodeRef(errorCodeRef, transactionId) }} </p>
      </div>
    </div>
  </template>

  <template v-else>
    <div class="grid">
      <div class="width-one-whole">
        <div class="alert" :class="errorTypeDanger ? 'alert-error' : 'alert-warning'"
          :role="errorTypeDanger ? 'error' : 'alert'">
          <div class="alert-body">
            <h3 class="alert-heading" data-i18n="basicauth.label_error">
              {{ getErrorTitle(errorTitle) }}
            </h3>
            <p class="alert-text" data-i18n="[html]credential_state.INVALID" data-i18n-options='{ "url": "" }'>
              {{
                getErrorMessage(errorMessage)
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
import { useI18n } from "vue-i18n";
import { ref } from "vue";
import store from "../store";
import { getCookie } from "../utils/useCookie";


export default {
  data() {
    return {
      errorMessage: null,
      errorTitle: null,
      errorCodeRef: null,
      transactionId: null
    }
  },
  computed: {
    redirect() {
      return store.getters.getRedirect;
    },
    errorTypeDanger() {
      return store.getters.getErrorType === 'danger';
    },
    agid() {
      return process.env.VUE_APP_SUB_PATH !== "tim";
    },
  },
  setup() {
    const { t, locale } = useI18n()
    const count = ref(0)
    return { count, t, locale }
  },
  beforeMount() {

    const errorCode = this.getParam('errorCode');
    this.errorCodeRef = "SPID.ERROR.CODEREF"
    this.transactionId = getCookie('transactionId')
    console.log('errorCode by param:' + errorCode);
    switch (Number(errorCode)) {
      case 2:
        this.errorTitle = "SPID.ERROR.TITLE.GENERIC";
        this.errorMessage = "SPID.ERROR.MESSAGE.UNKNOWN";

        break;
      case 3:
        this.errorTitle = 'SPID.ERROR.TITLE.SYSTEM';
        this.errorMessage = "SPID.ERROR.MESSAGE.UNKNOWN";
        break;
      case 4:
        this.errorTitle = 'SPID.ERROR.TITLE.BINDING';
        this.errorMessage = "SPID.ERROR.MESSAGE.BINDING";
        break;
      case 5:
        this.errorTitle = 'SPID.ERROR.TITLE.SIGN';
        this.errorMessage = "SPID.ERROR.MESSAGE.SIGN";
        break;
      case 6:
        this.errorTitle = 'SPID.ERROR.TITLE.BINDING_HTTP';
        this.errorMessage = "SPID.ERROR.MESSAGE.BINDING_HTTP";
        break;
      case 7:
        this.errorTitle = 'SPID.ERROR.TITLE.REQUESTED_SIGN';
        this.errorMessage = "SPID.ERROR.MESSAGE.REQUESTED_SIGN";
        break;
      case 10:
        this.errorTitle = 'SPID.ERROR.TITLE.ISSUER';
        this.errorMessage = "SPID.ERROR.MESSAGE.ISSUER";
        break;
      default:
        this.errorTitle = "SPID.ERROR.TITLE.GENERIC";
        this.errorMessage = "SPID.ERROR.MESSAGE.UNKNOWN";
    }

  },

  methods:
  {

    getErrorTitle(errorTitle) {
      console.log('getErrorTitle:' + errorTitle)
      return this.t(errorTitle, {}, { locale: this.locale });
    },
    getErrorMessage(errorMessage) {
      return this.t(errorMessage, {}, { locale: this.locale });
    },
    getErrorCodeRef(errorCodeRef, transactionId) {
      return this.t(errorCodeRef, {}, { locale: this.locale }) + transactionId;
    },
    getParam(name) {
      let urlParams = new URLSearchParams(window.location.search);
      let myParam = urlParams.get(name);
      return myParam;
    },
    handleRedirect() {
      if (!this.redirect) {
        return;
      }

      setTimeout(() => {
        const allowedRedirects = ['https://www.identitadigitale.infocert.it'];
        const redirectTo = this.$env.VUE_APP_WEBSITE_URL;
        if (allowedRedirects.includes(redirectTo)) {
          window.location.href = this.$env.VUE_APP_WEBSITE_URL;
        } else {
          console.error("Redirect URL not allowed: " + redirectTo);
        }
      }, Number(this.$env.VUE_APP_REDIRECT_TIME))
    }


  },
  mounted() {
    this.handleRedirect();
  }
}
</script>
<style scoped>
.ic1-centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ic1-card-error {
  /* Auto Layout */

  flex-direction: row;
  align-items: flex-start;
  padding: 0.625rem 1.75rem;
  position: static;
  width: fit-content;
  height: fit-content;
  left: 0px;
  top: 0px;

  /* danger-alternative */

  background: #fbe7e7;
  /* danger */

  border: 1px solid #da100b;
  box-sizing: border-box;
  border-radius: 5px;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 10px 0px;
}
</style>
